import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { loginRequest, msalInstance, silentRequest } from '../auth/msalConfig'
import axios from 'axios';
export interface AuthState {
    idToken: any,
    accessToken: any,
    account: any,
    error: any,
    loading: boolean,
    roles: string[],
    azuresearchId: any,
    showSessionTimeout: boolean,
}

const initialState: AuthState = {
    idToken: null,
    accessToken: null,
    account: null,
    error: null,
    loading: true,
    roles: [],
    azuresearchId: null,
    showSessionTimeout: false
}

const tokenExp = (token: string) => {
    const arrayToken = token.split('.');
    const tokenPayload = JSON.parse(atob(arrayToken[1]));
    return parseInt(tokenPayload?.exp) * 1000;
}

export const loginUser = createAsyncThunk('auth/loginUser', async (_, { rejectWithValue }) => {
    try {
        await msalInstance.loginRedirect(loginRequest)
    }
    catch (error: any) {
        return rejectWithValue(error.message)
    }
})

export const fetchRoles = createAsyncThunk("auth/fetchRoles", async (_, { getState, rejectWithValue }) => {
    try {
        const { idToken, account, roles } = (getState() as { auth: AuthState }).auth

        if (!idToken) return rejectWithValue("No token available")

        if (roles.length > 0) return roles
        const response = await axios.get(process.env.REACT_APP_GETUSERDATA as string + '?emailid=' + account, {
            headers: { Authorization: `Bearer ${idToken}` }
        })
        if (response.status === 401) {
            return rejectWithValue('token expired')
        }
        const responseData = response.data.response
        let rolesarr = []
        if (responseData.benchmarking === 'true') {
            rolesarr.push('benchmarking')
        }
        if (responseData.dg === 'true') {
            rolesarr.push('dg')
        }
        if (responseData.idm === 'true') {
            rolesarr.push('idm')
        }
        if (rolesarr.length === 0) {
            rolesarr.push('No roles available')
        }
        return rolesarr;
    }
    catch (error: any) {
        return rejectWithValue(error.message)
    }
})

export const fetchToken = createAsyncThunk('auth/fetchToken', async (_, { getState, rejectWithValue }) => {

    try {
        await msalInstance.handleRedirectPromise()
        const accounts = await msalInstance.getAllAccounts();
        if (accounts.length === 0) return rejectWithValue("No accounts found")

        const response = await msalInstance.acquireTokenSilent({
            ...silentRequest,
            account: accounts[0]
        })

        return {
            idToken: response.idToken,
            accessToken: response.accessToken,
            account: accounts[0].username,
            showSessionTimeout: false
        }
    }
    catch (error: any) {
        return rejectWithValue(error.message)
    }
})

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        logout: (state) => {
            msalInstance.logoutRedirect();
            state.idToken = null;
            state.accessToken = null;
            state.account = null;
            state.error = null
            state.loading = false
            state.azuresearchId = null
            state.showSessionTimeout = false;
        },
        sessionTimeout: (state, action: PayloadAction<boolean>) => {
            state.showSessionTimeout = action.payload
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchToken.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchToken.fulfilled, (state, action) => {
                state.idToken = action.payload.idToken;
                state.accessToken = action.payload.accessToken;
                state.account = action.payload.account;
                state.loading = false;
                state.azuresearchId = tokenExp(action.payload.idToken)
                state.showSessionTimeout = false
            })
            .addCase(fetchToken.rejected, (state, action) => {
                state.idToken = null;
                state.accessToken = null;
                state.error = action.payload
                state.account = null;
                state.loading = false;
                state.azuresearchId = null;
            })
            .addCase(fetchRoles.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchRoles.rejected, (state) => {
                state.loading = false;
            })
            .addCase(fetchRoles.fulfilled, (state, action) => {
                state.roles = action.payload;
                state.loading = false
            })
    }
})

export const { logout, sessionTimeout } = authSlice.actions
export default authSlice.reducer;